import Slider from './slider';
import TestimonialSlider from './testimonial-slider';

const slider = new Slider();
const tslider = new TestimonialSlider();

slider.init();
tslider.init();
